import classNames from 'classnames';
import { FieldHelperProps, FieldInputProps, FieldMetaProps, FormikContextType, useField, useFormikContext } from 'formik';
import { RefObject } from 'react';

export interface BaseFieldProps {
    name: string;
    label?: React.ReactNode;
    renderLabel?: () => React.ReactNode;
    hint?: string;
    wrapperClassName?: string;
    required?: boolean;
    placeholder?: string;
    capitalize?: boolean;
    disabled?: boolean;
}

export interface BaseTextFieldProps extends BaseFieldProps {
    textareaRef?: RefObject<HTMLTextAreaElement>;
    autoFocus?: boolean;
    maxLength?: number;
    formControlClassName?: string;
    autoTrim?: boolean;
}

interface InputFieldProps extends BaseFieldProps {
    renderElement: (
        formik: FormikContextType<any>,
        field: FieldInputProps<any>,
        meta: FieldMetaProps<any>,
        helpers: FieldHelperProps<any>
    ) => React.ReactElement;
}

export const InputField = ({ name, label, renderLabel, hint, renderElement, wrapperClassName, required, capitalize = true }: InputFieldProps) => {
    const formik = useFormikContext();
    const [field, meta, helpers] = useField(name);

    return (
        <div className={classNames('data-item-row', wrapperClassName)} onClick={(e) => e.stopPropagation()}>
            {label ? (
                <label className={classNames('data-item-col data-item-col-title', { 'data-item-capitalize': capitalize })}>
                    {label}
                    {required && <span className="text-red"> *</span>}
                </label>
            ) : renderLabel?.()}
            {renderElement(formik, field, meta, helpers)}
            {hint && <span className="data-item-hint">{hint}</span>}
        </div>
    );
}
